import {
  Component,
  ElementRef,
  Input,
  OnInit,
  forwardRef,
} from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-date-range-type',
  templateUrl: './select-date-range-type.component.html',
  styleUrls: ['./select-date-range-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDateRangeTypeComponent),
      multi: true,
    },
  ],
})
export class SelectDateRangeTypeComponent implements OnInit {
  @Input() selectDatesText!: string;
  @Input() isFocused: string | null | undefined = null;

  rangeInterval = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
  });

  onChange: any;
  onTouch: any;
  dateRange!: any;

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(counter: number) {
    this.dateRange = counter;
  }

  private subscriptions = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.rangeInterval.valueChanges.subscribe((range: any) => {
        this.dateRange = range;

        this.onChange(this.dateRange);
      })
    );
  }
}
